// extracted by mini-css-extract-plugin
export default {"avatar":"aajOFr","withBorder":"JRPSQC","memberInitials":"SmsxrS","avatarPlaceholder":"I_KotS","withLoggedOutHeight":"HrjDXf"};